import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {useAuthLink} from '@app/hooks/use-link';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '3bf380bb9ae9bce8fb6bf101264228ef.png',
	fr: '0735aa5966e100d332159cdce30215a8.png',
};

export const FeaturesHero: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getRegistrationLink} = useAuthLink();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h1">
						{t(
							'featureslandingpage_title_auniqueXPonlyondeezer_standalone-web',
							{ns: 'features'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_auniqueXPonlyondeezer_standalone-web',
							{
								sprintf: ['90'],
								ns: 'features',
							},
						)}
					</LandingParagraph>
					<LandingButtonLink
						tracking={{eventaction: 'signup'}}
						href={getRegistrationLink()}
						isMain
					>
						{t('generic_action_signupforfree_standalone-web', {ns: 'common'})}
					</LandingButtonLink>
				</>
			}
			image={
				<Image
					aspectRatio="2880/840"
					alt={t('metatag_text_deezeroncompatibledevices_standalone-web', {
						ns: 'common',
					})}
					src={src}
					priority
					quality={100}
				/>
			}
		/>
	);
};
